import Skeleton from '@mui/material/Skeleton';

function ErrorCardSkeleton() {
    return <Skeleton variant="rounded" width="100%" height={90} />;
}

export default ErrorCardSkeleton;
